import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IContentWithContextType } from '../../common/interfaces/ContentWithContextType';

interface ContentState {
  isModalOpen: boolean;
  isModalOpenedForAdd: boolean;
  selectedContent: IContentWithContextType | null;
  validationErrors: { [field: string]: string[] };
}

const initialState: ContentState = {
  isModalOpen: false,
  isModalOpenedForAdd: false,
  selectedContent: null,
  validationErrors: {},
};

const contentSlice = createSlice({
  name: 'content',
  initialState,
  reducers: {
    setSelectedContent(
      state,
      action: PayloadAction<IContentWithContextType | null>
    ) {
      state.selectedContent = action.payload;
    },
    clearSelectedContent(state) {
      state.selectedContent = null;
    },
    openContentModal(
      state,
      action: PayloadAction<{ isModalOpenedForAdd?: boolean } | undefined>
    ) {
      state.isModalOpen = true;
      state.isModalOpenedForAdd = action?.payload?.isModalOpenedForAdd ?? false;
    },
    closeContentModal(state) {
      state.isModalOpen = false;
      state.isModalOpenedForAdd = false;
    },
    setValidationErrors(
      state,
      action: PayloadAction<{ field: string; errors: string[] }>
    ) {
      state.validationErrors[action.payload.field] = action.payload.errors;
    },
    clearValidationErrors(state, action: PayloadAction<string>) {
      delete state.validationErrors[action.payload];
    },
    clearAllValidationErrors(state) {
      state.validationErrors = {};
    },
  },
});

export const {
  setSelectedContent,
  clearSelectedContent,
  openContentModal,
  closeContentModal,
  setValidationErrors,
  clearValidationErrors,
  clearAllValidationErrors,
} = contentSlice.actions;
export default contentSlice.reducer;
